import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { ImageSearchUploadMethod, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type ImageUploadedUniquePayload = {
    // Ships as the `Upload Method` Amplitude property (camelCase keys are title-cased by
    // convertPayloadToHumanReadableFieldNames in the track() layer).
    uploadMethod: ImageSearchUploadMethod;
};

type ImageUploadedPayload = TrackingPayload & ImageUploadedUniquePayload;

export const trackImageUploadedAnalytics = (payload: ImageUploadedPayload) => {
    track(TrackingEvents.SearchByImage.ImageUploaded, payload);
};

export const useTrackImageUploadedAnalytics = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ uploadMethod }: ImageUploadedUniquePayload) => {
            trackImageUploadedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname),
                uploadMethod,
                url: getFullUrl(deployment, pathname),
            });
        },
        [deployment, pathname]
    );
};
